import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

type Params = {
  idPartner: number;
};

export async function getPartnerAvatarURL(
  params: Params
): Promise<null | string> {
  const url = getM8AdminURL(
    `getPartnerAvatar?${createQueryString({
      ...params,
      uniqueRuntimeKey: createUniqueRuntimeNumber(),
    })}`
  );

  const response = await fetch(url);

  if (response.ok) {
    return url;
  }

  return null;
}
